import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

export const getTaxTypesEffects = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentTaxType`,
    method: 'get',
  });
};

export const getPricingBasisEffects = () => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetPricingBasis`,
    method: 'get',
  });
};

export const getPricingTypesEffects = () => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetPricingType`,
    method: 'get',
  });
};

export const getMeasurementUnitsEffects = () => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetMeasurementUnit`,
    method: 'get',
  });
};

export const getLinerCodesEffects = () => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetLiner`,
    method: 'get',
  });
};

export const getPaymentTypesEffects = () => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GePaymentType`,
    method: 'get',
  });
};
